import { useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { useEffect, useState } from "react";
import moment from "moment";
import { formatAmount } from "../../../utility/CommonFunctions";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import DocumentIcon from "../../../components/Icons/DocumentIcon";

export default function ReimbursementDetails() {
  let { id } = useParams();
  const navigate = useNavigate();
  const [dataLoading, setDataLoading] = useState(false);
  const [reimbursementFormData, setReimbursementFormData] = useState();
  let totalAmount = 0;
  let totalAmountWithGST = 0;
  useEffect(() => {
    GetReimbursementDetail();
  }, []);
  const [docModal, setDocModal] = useState(false);
  const toggleDocModal = () => {
    setDocModal(!docModal);
  };
  const [selectedDocument, setSelectedDocument] = useState(null);

  const GetReimbursementDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_reimbursement_details + `?reimbursementFormId=${id}`;
    setDataLoading(true);
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setReimbursementFormData(response?.data);
      }
    });
  };

  const getAmount = (qty, rate) => {
    return formatAmount(Number(qty) * rate);
  };
  const getAmountWithGst = (gst, total) => {
    return formatAmount((Number(gst) * total) / 100 + total);
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    toggleDocModal();
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="content-head mb-5 d-flex align-items-start justify-content-between">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <button
                role="button"
                className="btn back-arrow"
                onClick={() => navigate(-1)}
              >
                <BackArrowIcon />
              </button>
              <h1 className="mb-0">Reimbursement Form Details</h1>
            </div>
          </div>
        </div>
        <form action="">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <ul
                        className={
                          dataLoading
                            ? "row list-unstyled mt-4 loading-skeleton"
                            : "row list-unstyled mt-4"
                        }
                      >
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Site :-
                            </span>
                            {reimbursementFormData?.site?.name || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Amount :-
                            </span>
                            {formatAmount(reimbursementFormData?.amount) ||
                              "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Date :-
                            </span>
                            {reimbursementFormData?.date
                              ? moment(reimbursementFormData?.date).format(
                                "DD-MM-YYYY"
                              )
                              : "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              GST Type :-
                            </span>
                            {reimbursementFormData?.gstType || "--"}
                          </p>
                        </li>
                        <li className="col-12 col-md-6 col-lg-4">
                          <p>
                            <span className="text-muted fs-5 d-block">
                              Description :-
                            </span>
                            {reimbursementFormData?.description || "--"}
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-12 ">
                      <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                        <h4 className="fs-3 rajdhani-semibold my-4">
                          Item Details
                        </h4>
                      </div>

                      <div>
                        <table className="table mt-3">
                          <thead>
                            <tr>
                              <th>Item</th>
                              <th>Quantity</th>
                              <th>Rate</th>
                              <th>Amount</th>
                              {reimbursementFormData?.gstType === "IGST" && (
                                <th>IGST</th>
                              )}
                              {reimbursementFormData?.gstType ===
                                "CGST + SGST" && (
                                  <>
                                    <th>CGST</th>
                                    <th>SGST</th>
                                  </>
                                )}
                              <th>Amount With GST</th>
                            </tr>
                          </thead>

                          <tbody>
                            {reimbursementFormData?.reimbursementFormItems?.map(
                              (item, i) => {
                                const amount =
                                  parseFloat(item?.quantity) *
                                  parseFloat(item?.rate);
                                const gstAmount =
                                  (amount * parseFloat(item?.gst)) / 100;

                                totalAmount += amount;
                                totalAmountWithGST += gstAmount;

                                return (
                                  <tr key={i}>
                                    <td className="desc-wrapper">
                                      {item?.item}
                                    </td>
                                    <td className="desc-wrapper">
                                      {item?.quantity}
                                    </td>
                                    <td className="desc-wrapper">
                                      {item?.rate}
                                    </td>
                                    <td className="desc-wrapper">
                                      {getAmount(item?.quantity, item?.rate)}
                                    </td>

                                    {reimbursementFormData?.gstType ===
                                      "IGST" && (
                                        <td className="desc-wrapper">
                                          {formatAmount(
                                            (item?.quantity *
                                              item?.rate *
                                              item?.gst) /
                                            100
                                          )}{" "}
                                          ({item?.gst || 0}%)
                                        </td>
                                      )}

                                    {reimbursementFormData?.gstType ===
                                      "CGST + SGST" && (
                                        <>
                                          <td className="desc-wrapper">
                                            {formatAmount(
                                              (item?.quantity *
                                                item?.rate *
                                                item?.gst) /
                                              2 /
                                              100
                                            )}{" "}
                                            ({item?.gst / 2 || 0}%)
                                          </td>
                                          <td className="desc-wrapper">
                                            {formatAmount(
                                              (item?.quantity *
                                                item?.rate *
                                                item?.gst) /
                                              2 /
                                              100
                                            )}{" "}
                                            ({item?.gst / 2 || 0}%)
                                          </td>
                                        </>
                                      )}

                                    <td className="desc-wrapper">
                                      {getAmountWithGst(
                                        item?.gst,
                                        item?.quantity * item?.rate
                                      )}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>

                          <tfoot>
                            {/* Taxable Value */}
                            <tr>
                              <td
                                colSpan={
                                  reimbursementFormData?.gstType === "IGST"
                                    ? 4
                                    : reimbursementFormData?.gstType ===
                                      "CGST + SGST"
                                      ? 5
                                      : 4
                                }
                              ></td>
                              <td className="fw-bold">Taxable Value</td>
                              <td>{formatAmount(totalAmount)}</td>
                            </tr>

                            {/* IGST */}
                            {reimbursementFormData?.gstType === "IGST" && (
                              <tr>
                                <td colSpan={4}></td>
                                <td className="fw-bold">IGST</td>
                                <td>{formatAmount(totalAmountWithGST)}</td>
                              </tr>
                            )}

                            {/* CGST + SGST */}
                            {reimbursementFormData?.gstType ===
                              "CGST + SGST" && (
                                <tr>
                                  <td colSpan={3}></td>
                                  <td className="fw-bold">CGST</td>
                                  <td>{formatAmount(totalAmountWithGST / 2)}</td>
                                  <td className="fw-bold">SGST</td>
                                  <td>{formatAmount(totalAmountWithGST / 2)}</td>
                                </tr>
                              )}

                            {/* Total Amount */}
                            <tr>
                              <td
                                colSpan={
                                  reimbursementFormData?.gstType === "IGST"
                                    ? 4
                                    : reimbursementFormData?.gstType ===
                                      "CGST + SGST"
                                      ? 5
                                      : 4
                                }
                              ></td>
                              <td className="fw-bold">Total Amount</td>
                              <td>
                                {formatAmount(totalAmount + totalAmountWithGST)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>

                      <div className="d-flex align-items-center justify-content-end border-bottom mb-4">
                        <h4 className="fs-3 rajdhani-semibold my-4">
                          Grand Total :{" "}
                          {formatAmount(totalAmount + totalAmountWithGST)}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="row">
        <div className="col-12 ">
          <div className="card manage-user-list">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                <h4 className="d-flex align-items-center mb-4">Documents</h4>
              </div>
              <ul className="row list-unstyled gap-3">
                {reimbursementFormData?.documents?.length > 0 ? (
                  reimbursementFormData?.documents?.map((doc, index) => {
                    return (
                      <li className="col-12">
                        <div
                          className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                          onClick={() => handleDocumentClick(doc)}
                          role="button"
                        >
                          <span className="d-flex align-items-center gap-2">
                            <DocumentIcon />
                            {doc?.name || "Document"}
                          </span>
                          <span className="fs-6">
                            {doc?.updatedAt ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                          </span>
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <div>No Document Found</div>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ViewDocumentModal
        modal={docModal}
        toggle={toggleDocModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
